module.exports = __webpack_public_path__ + "assets/MSOnline.f32b3f89.svg";